export const ITEMS_PER_PAGE = 10;
export const MAX_ITEMS = 10;
export const MAX_ITEMS_MOBILE = 5;
export const TOTAL_PAGE_ITEMS = MAX_ITEMS - 2; // 2 ellipsis
export const TOTAL_PAGE_ITEMS_MOBILE = 3; // 2 ellipsis
export const ELLIPSIS = '...';
